/**
 * Runs a callback and hands anything it throws — or a returned promise that
 * rejects — to `onError` instead of letting it escape.
 *
 * For fanning out to listeners the caller does not control: one failing
 * listener must not stop the others, and an emitter like nanoevents does not
 * catch for you, so a throw would otherwise travel up into its dispatch loop.
 */
export function callSafely(
  callback: () => void | Promise<void>,
  onError: (error: unknown) => void
): void {
  try {
    const result = callback();
    if (result instanceof Promise) {
      result.catch(onError);
    }
  } catch (error: unknown) {
    onError(error);
  }
}
